/**
 * API 配置文件
 * 根据环境变量配置不同的 API 地址
 */

export interface ApiConfig {
    baseURL: string
    apiPrefix: string
    timeout: number
    withCredentials: boolean
    enableProxy: boolean
}

// 根据环境获取配置
export const getApiConfig = (): ApiConfig => {
    const baseURL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:8080'
    const apiPrefix = import.meta.env.VITE_API_PREFIX || '/api'
    const enableProxy = import.meta.env.VITE_ENABLE_PROXY === 'true'

    // 如果是开发环境且启用代理，使用相对路径
    const finalBaseURL = enableProxy ? apiPrefix : `${baseURL}${apiPrefix}`

    return {
        baseURL: finalBaseURL,
        apiPrefix,
        timeout: 30000, // 30秒
        withCredentials: true, // 允许携带 cookie
        enableProxy
    }
}

// 获取 WebSocket 地址
export const getWebSocketUrl = (): string => {
    const baseUrl = import.meta.env.VITE_WS_URL || 'ws://localhost:8080'
    const enableProxy = import.meta.env.VITE_ENABLE_PROXY === 'true'

    return enableProxy ? '/ws' : baseUrl
}

// 获取完整 API URL
export const getApiUrl = (endpoint: string): string => {
    const config = getApiConfig()
    const base = config.baseURL.replace(/\/$/, '')
    const path = endpoint.replace(/^\//, '')
    return `${base}/${path}`
}

// 导出默认配置
export default getApiConfig()